<template>
  <div class="component-desktop-menu">
    <ul>
      <li class="desktop-only">
        <router-link to="/">Início</router-link>
      </li>
      <li class="mobile-only">
        <span id="menu-popover">
          Menu
          <i class="icon-chevron-down" />
        </span>
        <b-popover
          triggers="hover"
          target="menu-popover"
          placement="bottom-start"
          custom-class="menu-popover"
          :show.sync="showMenuPopover"
        >
          <router-link to="/">Início</router-link>
          <router-link :to="{ name: 'tools' }">Ferramentas</router-link>
          <router-link :to="{ name: 'community' }">Dúvidas</router-link>
          <router-link :to="{ name: 'mentorship' }"
            >Mentorias ao Vivo</router-link
          >
        </b-popover>
      </li>
      <li>
        <span id="modules-popover">
          Módulos
          <i class="icon-chevron-down" />
        </span>
        <b-popover
          triggers="hover"
          target="modules-popover"
          placement="bottom-start"
          custom-class="menu-popover module-popover"
          :show.sync="showModulesPopover"
        >
          <div class="row">
            <div class="col-lg-6 py-2">
              <h6>Ciclo básico</h6>
              <div class="row">
                <div
                  class="col-xl-6"
                  v-for="(course, i) in basicCourses"
                  :key="i"
                >
                  <router-link
                    :to="{ name: 'course', params: { ...course } }"
                    :title="course.title"
                  >
                    {{ course.title }}
                  </router-link>
                </div>
              </div>
            </div>
            <div class="col-lg-6 py-2">
              <h6>Avançado</h6>
              <div class="row">
                <div
                  class="col-xl-6"
                  v-for="(course, i) in advancedCourses"
                  :key="i"
                >
                  <router-link
                    :to="{ name: 'course', params: { ...course } }"
                    :title="course.title"
                  >
                    {{ course.title }}
                  </router-link>
                </div>
              </div>
            </div>
          </div>
        </b-popover>
      </li>
      <li class="desktop-only">
        <router-link :to="{ name: 'tools' }">Ferramentas</router-link>
      </li>
      <li class="desktop-only">
        <router-link :to="{ name: 'community' }">Dúvidas</router-link>
      </li>
      <li class="desktop-only">
        <router-link :to="{ name: 'mentorship' }"
          >Mentorias ao Vivo</router-link
        >
      </li>
    </ul>
  </div>
</template>

<script>
import { watch } from "vue";
import { mapState } from "vuex";
export default {
  data() {
    return {
      showMenuPopover: false,
      showModulesPopover: false
    };
  },
  computed: {
    ...mapState("courses", ["courses"]),
    advancedCourses() {
      return this.courses.filter(c =>
        c.title.toLowerCase().includes("ao vivo")
      );
    },
    basicCourses() {
      return this.courses.filter(
        c => !c.title.toLowerCase().includes("ao vivo")
      );
    }
  },
  watch: {
    "$route.path": {
      handler() {
        this.showMenuPopover = false;
        this.showModulesPopover = false;
      }
    }
  }
};
</script>

<style lang="scss">
.component-desktop-menu {
  display: flex;
  justify-content: center;
  ul {
    display: flex;
    justify-content: center;
    gap: 16px;
    list-style: none;
    padding: 0;
    margin: 0;

    @media screen and (min-width: 992px) {
      width: 80%;
      gap: 72px;
    }

    .icon-chevron-down {
      @media screen and (min-width: 992px) {
        margin-left: 12px;
      }
    }

    #modules-popover {
      display: inline-flex;
      align-items: center;
      &:hover {
        cursor: pointer;
      }
      i {
        font-size: 20px !important;
      }
    }
    a {
      text-decoration: none;
      color: white;
      transition: color 0.2s;
      padding: 12px 0;
      &.router-link-active {
        font-weight: bold;
      }
      &:hover {
        color: #ddd;
      }
    }
  }
}
</style>
